var $fd19cc1d41a750e5$exports = {};
$fd19cc1d41a750e5$exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`
};


export {$fd19cc1d41a750e5$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
